import {
  emptyValidator,
  formValidator,
  greaterThanZeroValidator,
} from "../../validators";

const requestApprovalValidationState = {
  status: {
    validators: [emptyValidator()],
    name: "Status",
  },
  remark: {
    validators: [emptyValidator()],
    name: "Remark",
  },
  remarkDesc: {
    validators: [emptyValidator()],
    name: "Remarks description",
  },
  chargeType: {
    validators: [emptyValidator()],
    name: "Charge Type",
  },
  route: {
    validators: [emptyValidator()],
    name: "Route",
  },
  jobType: {
    validators: [emptyValidator()],
    name: "Job Type",
  },
  numOfJobs: {
    validators: [emptyValidator(), greaterThanZeroValidator()],
    name: "Number of Jobs",
  },
};

export const requestApprovalValidation = (requestApproval) => {
  return formValidator(requestApproval, requestApprovalValidationState);
};
